export default "__VITE_ASSET__CNFfVOQp__"